import { lazy } from "react";

export type { IAddDescriptionPopup } from "./types";

export const AddDescriptionPopup = lazy(() => import("./AddDescriptionPopup"));
